"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIN_ITEMS_TO_SEARCH = exports.TIME_DELAY_CLOSE_DIALOG = exports.DELAY_INPUT_UPDATE_MILLISECONDS = exports.MAX_LENGTH_PHONE = exports.MAX_DURATION_HOUR = exports.MAX_DURATION_MINUTE = exports.MIN_DURATION_HOUR = exports.MIN_DURATION_MINUTE = exports.DEFAULT_DURATION_HOURS = exports.DEFAULT_DURATION_MINUTES = exports.MAX_LENGTH_ABOUT_300_WORDS = exports.MAX_LENGTH_EMAIL = exports.MAX_LENGTH_DESCRIPTION = exports.MAX_LENGTH_NAME = exports.NON_AI_ENGAGE_TEAM_MEMBERS_LIMIT = exports.DEFAULT_INTERVAL_COUNT = exports.INBOX_SPOTS_LIMIT = exports.INBOX_DAY_LIMIT = exports.SLOTS_DURATION_MARGIN_MS = exports.SLOTS_DURATION_MARGIN_MINUTES = exports.SLOTS_MAX_DAYS_PER_DAY = exports.SLOTS_MAX_DAYS = void 0;
exports.SLOTS_MAX_DAYS = 4;
exports.SLOTS_MAX_DAYS_PER_DAY = 4;
exports.SLOTS_DURATION_MARGIN_MINUTES = 15;
exports.SLOTS_DURATION_MARGIN_MS = exports.SLOTS_DURATION_MARGIN_MINUTES * 60 * 1000;
exports.INBOX_DAY_LIMIT = 4;
exports.INBOX_SPOTS_LIMIT = 3;
exports.DEFAULT_INTERVAL_COUNT = 15;
exports.NON_AI_ENGAGE_TEAM_MEMBERS_LIMIT = 5;
exports.MAX_LENGTH_NAME = 40;
exports.MAX_LENGTH_DESCRIPTION = 500;
exports.MAX_LENGTH_EMAIL = 320;
exports.MAX_LENGTH_ABOUT_300_WORDS = 2000;
exports.DEFAULT_DURATION_MINUTES = 30;
exports.DEFAULT_DURATION_HOURS = 1;
exports.MIN_DURATION_MINUTE = 5;
exports.MIN_DURATION_HOUR = 1;
exports.MAX_DURATION_MINUTE = 720;
exports.MAX_DURATION_HOUR = 12;
exports.MAX_LENGTH_PHONE = 16;
exports.DELAY_INPUT_UPDATE_MILLISECONDS = 300;
exports.TIME_DELAY_CLOSE_DIALOG = 3000;
exports.MIN_ITEMS_TO_SEARCH = 6;
